module.exports = __webpack_public_path__ + "img/clouds-sun.3d4b85f7.svg";